import type { ClientTagType } from './client/ClientTag';
import type { PeopleType } from './client/PeopleType';
import type { DateInterval } from './DateInterval';
import type { Translations } from './Translation';
import type User from './user/User';

export enum DistributionSchedulingType {
  Immediate = 0,
  EffectiveDate = 1,
  FixedDate = 2,
}

export enum DistributionStatus {
  InActive = 0,
  Active = 1,
  Completed = 2,
}

export enum DistributionStatusFilter {
  InActive = DistributionStatus.InActive,
  Active = DistributionStatus.Active,
  Completed = DistributionStatus.Completed,
  ActionNeededByCurrentUser = 99,
}

export enum DistributionMemberStatus {
  Created = 0,
  Pending = 1,
  Acknowledged = 2,
  Signed = 3,
  Incomplete = 4,
}

export type DistributionSettings = {
  enableAcknowledgementSignature: boolean;
  automaticSendUncontrolledCopy: boolean;
  enableUncontrolledCopyWatermark?: boolean;
};

export type DistributionPreferences = {
  scheduleType: DistributionSchedulingType;
  scheduleFixedDate: string | null;
  reminderFrequencyValue: number | null;
  reminderFrequencyInterval: DateInterval | null;
  notifyOnReady: boolean;
  notifyOnSuccessful: boolean;
  linkExpirationAmount: number | null;
  linkExpirationInterval: DateInterval | null;
  linkExpirationDate: string | null;
};

export type DistributionMember = {
  distributionId: string;
  memberId: string;
  type: PeopleType;
  status: DistributionMemberStatus;
  statusUtc: string;
  notifiedOnUtc?: string;
  reminderSentUtc?: string;
  addedAsIndividual?: boolean;
  tagIds?: string[];
};

export type DistributionUserTag = {
  id: string;
  type: ClientTagType;
  synchronized: boolean;
  translations: Translations<'name'>;
  users?: User[];
};

export type DistributionUserGroupResponse = {
  memberType: PeopleType;
  synchronized: boolean;
  tag: DistributionUserTag;
};

export type DistributionResponse = {
  id: string;
  clientFormId: string;
  clientFormVersion: number;
  startDate?: string;
  scheduleType: DistributionSchedulingType;
  status: DistributionStatus;
  members: DistributionMember[];
  tags: DistributionUserGroupResponse[];
  settings: DistributionSettings;
  preferences: DistributionPreferences;
  createdBy: string;
  createdById: string;
};
